// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rhbK\\+s8PlW5Scvj-TaL-qQ\\=\\={margin-bottom:3.2rem;margin-left:auto;margin-right:auto;text-align:center}._0R1a06uTuLthScJpVkl8sQ\\=\\={margin-bottom:.8rem;margin-top:3.2rem}.DXQY5loI4KiXrmOyvEWHpw\\=\\={height:100%;min-height:32rem;width:100%}.DXQY5loI4KiXrmOyvEWHpw\\=\\= .echarts{height:32rem;width:100%}@media screen and (min-width:480px){.DXQY5loI4KiXrmOyvEWHpw\\=\\={min-height:40rem}.DXQY5loI4KiXrmOyvEWHpw\\=\\= .echarts{height:40rem}}.DXQY5loI4KiXrmOyvEWHpw\\=\\= .echarts>div{width:auto!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radar": "rhbK+s8PlW5Scvj-TaL-qQ==",
	"radarTitle": "_0R1a06uTuLthScJpVkl8sQ==",
	"echartsWrapper": "DXQY5loI4KiXrmOyvEWHpw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
